import { range } from 'lodash-es';
import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';

export const ToolbarSkeleton: FC<{ count: number }> = ({ count }) => {
  return (
    <div className="d-flex flex-row bg-lvl1 w-100 align-items-center py-2 px-4">
      <div className="d-flex justify-content-center align-items-center border mx-2 p-2">
        <span className="fw-bold color-primary">
          <Skeleton width="8em" />
        </span>
      </div>
      <div className="border w-1 h-100 mx-2" />
      <div className="text-primary mx-2 d-flex">
        {range(0, count).map(id => (
          <Skeleton key={id} width="15em" className="mx-2" />
        ))}
      </div>
    </div>
  );
};
